import Debug from 'debug';
import { customElement, property } from 'lit/decorators.js';
import {html, LitElement, nothing, PropertyValues} from 'lit';
import { dataBroker } from '../services/DataBroker';
import { PqdSqlClient } from './pdq-sqlite-client';
import { sqliteBroker } from '../services/SqliteBroker';
import {defer, extractTextFromScripts} from "../utils";

const log = Debug('pdq:sqlite:database');
@customElement('pdq-sqlite-local-database')
export class PdqSqliteLocalDatabase extends LitElement  {
  #firstRun = true
  #skipWaitForDbFlag =  defer()
  #scriptsLoaded = defer()
  @property({type: String}) database: string | undefined

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.refresh().catch(e => log(`failed to refresh - ${e}`))
  }
  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);
    this.refresh().catch(e => log(`failed to refresh - ${e}`))
  }

  cacheKey = ''
  async refresh(){
    if (!this.database) {
      log(`refresh failed... no database path / name`)
      return
    }
    const ck = `${this.database}`
    if (this.cacheKey == ck)
      return
    this.cacheKey = ck
    log(`opening local sqlite instance[${this.database}]`)
    const client = await sqliteBroker.getDatabaseClient(this.database)
    await client.open(this.database)

    if (this.#firstRun && this.querySelector('[slot="script"]')) {
      log(`local sqlite instance[${this.database}] is open but waiting for script slot`)
      this.#skipWaitForDbFlag.resolve(undefined);
      await this.#scriptsLoaded.promise.then(() => {
        this.#firstRun = false
        this.#skipWaitForDbFlag = defer() // dont resolve again...
        sqliteBroker.setDatabaseReady(this.database)
        log(`local sqlite instance[${this.database}] is open and ready`)
      })


     }else {
      sqliteBroker.setDatabaseReady(this.database)
      log(`local sqlite instance[${this.database}] is open and ready`)
    }

  }

  render = () => {
    return html`<slot style="display: none;" name="script" @slotchange="${this._onScriptsSlotChange}"></slot>`;
  }

  private async _onScriptsSlotChange(event: Event) {
    log(`${this.id} - script slot change`);
    if (!this.database)
      return

    try {
      const slot = event.target as HTMLSlotElement;
      const nodes = slot.assignedNodes({ flatten: true });
      const script = extractTextFromScripts(nodes);

      const database = this.database;
      await Promise.any([sqliteBroker.getDatabaseReadyPromise(database), this.#skipWaitForDbFlag.promise]);
      const client = await sqliteBroker.getDatabaseClient(database)
      await client.script(script, [{ database }]);
      this.#scriptsLoaded.resolve(true)
      log(`${this.id} - script slot change complete`);
    }catch (e) {
      log(`${this.id} - script slot change failed - ${e}`);
    }
  }
}